let MEM = {};

export class FormRollback {

    static initForms() {
        [...document.querySelectorAll('form[id]')].forEach(FormRollback.saveForm);
    }

    static saveForm(form) {

        // není zapamatován nebo byl přepsán //
        if (MEM[form.id]?.element !== form) {
            MEM[form.id] = {
                element : form,
                html : form.innerHTML,
            };

        }

    }

    static rollbackAll() {
        Object.keys(MEM).forEach(FormRollback.rollbackForm);
    }

    static rollbackForm(id) {
        try {
            if (!MEM[id]) throw "Neuloženo";
            let form;
            if (!(form = MEM[id].element ?? document.querySelector('form[id="'+id+'"]')).offsetParent) {
                throw "Formulář není na stránce";
            }
            form.innerHTML = MEM[id].html;
            MEM[id].element = form;
        } catch(e) {
            console.error('Nelze rollbacknout formulář '+id);
            console.error(e);
        }
        try {
            window.initCombobox?.('', 'reset');
        } catch(e) {}
    }

}